import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SearchResponse } from '@woolworthsnz/trader-api';
import { Observable } from 'rxjs';
import { SearchService } from './search.service';

@Injectable({
	providedIn: 'root',
})
export class SearchResultsResolver {
	constructor(private searchService: SearchService) {}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<SearchResponse> {
		return this.searchService.fetchProductsFromRoute(route, state);
	}
}
